







import {Vue,Component,Prop, Watch} from 'vue-property-decorator';
@Component
export default class ToggleSwitch extends Vue {
    checked = false;
    @Watch('checked')
    onCheckedChanged(){
        this.$emit('checked-changed',this.checked);
    }
    @Prop() isReadOnly?: boolean;
    @Prop() checkedProp?: boolean;
    @Watch('checkedProp')
    onCheckPropChanged(newVal: boolean, oldVal: boolean){
      this.checked = newVal;
    }
    created(){
      if(this.checkedProp)
        this.checked = this.checkedProp;
    }
    onClick(){
      this.$emit("click");
    }
}

